/* Shared social links used by the Footer and About page */
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

export const socialLinks = [
  { icon: AiFillGithub, href: "https://github.com/kcullen3" },
  { icon: AiOutlineTwitter, href: "https://x.com/KeiganCullen" },
  { icon: FaLinkedinIn, href: "https://www.linkedin.com/in/keigan-cullen-000551171/" },
  { icon: AiFillInstagram, href: "https://www.instagram.com/keigancullen" },
];
